export default {
  header: "My Facts Page",
  view: "Facts"
};
